const RICH_TEXT_COLLAPSED_CLASS = 'rich-text__blocks--collapsed';

class RichTextCollapse extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('button');
    this.content = document.getElementById(this.dataset.content);
    if (!this.toggleButton || !this.content) return;

    this.labelMore = this.querySelector('[data-collapse-label-more]');
    this.labelLess = this.querySelector('[data-collapse-label-less]');

    this.onToggle = this.onToggle.bind(this);
    this.onContentFocus = this.onContentFocus.bind(this);
    this.update = this.update.bind(this);

    this.toggleButton.addEventListener('click', this.onToggle);
    this.content.addEventListener('focusin', this.onContentFocus);

    this.update();

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.content);
    } else {
      window.addEventListener('resize', this.update);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener('resize', this.update);
  }

  get expanded() {
    return this.toggleButton.getAttribute('aria-expanded') === 'true';
  }

  get collapsedHeight() {
    const value = parseFloat(getComputedStyle(this.content).getPropertyValue('--rich-text-collapsed-height'));
    return isNaN(value) ? null : value;
  }

  update() {
    const limit = this.collapsedHeight;
    if (limit === null) return;

    const overflows = this.content.scrollHeight > limit + 1;
    this.classList.toggle('hidden', !overflows);
    if (this.expanded) return;

    this.content.classList.toggle(RICH_TEXT_COLLAPSED_CLASS, overflows);
  }

  onToggle() {
    if (this.expanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  onContentFocus() {
    if (this.content.classList.contains(RICH_TEXT_COLLAPSED_CLASS)) this.expand();
  }

  expand() {
    this.content.classList.remove(RICH_TEXT_COLLAPSED_CLASS);
    this.setState(true);
  }

  collapse() {
    this.content.classList.add(RICH_TEXT_COLLAPSED_CLASS);
    this.setState(false);
    if (this.content.getBoundingClientRect().top < 0) {
      this.content.scrollIntoView({ block: 'start' });
    }
  }

  setState(expanded) {
    this.toggleButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (this.labelMore) this.labelMore.hidden = expanded;
    if (this.labelLess) this.labelLess.hidden = !expanded;
  }
}

customElements.define('rich-text-collapse', RichTextCollapse);
